<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item>
						<template>
							<el-form-item label="分类名称:" class='tiny' cleartable>
								<el-input style="width: 200px;" v-model="searchInfo.className" placeholder="请输入一级分类名称"></el-input>
							</el-form-item>
							<el-button type="primary" @click="search">搜索</el-button>
							<el-button @click="empty">清空</el-button>
							<el-button type="primary" @click="editialogVisible('',1)">新增推荐分类
							</el-button>
							<!-- <el-button type="primary" @click="editialogVisible('',2)">新增二级分类
							</el-button>
							<el-button type="primary" @click="editialogVisible('',3)">新增三级分类
							</el-button> -->
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<el-table :data="goodsClassList" style="width: 100%" row-key="id" :header-cell-style="headClass" lazy
			v-loading="loading" element-loading-text="拼命加载中">
		
			<el-table-column prop="orderIndex" label="排序级别" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="className" label="分类名" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="image" label="分类图标" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<img v-if="scope.row.image" :src="scope.row.image"
						@click="dialogImageUrl=scope.row.image;dialogVisibleImg=true;" width="64px" />
					<div v-else>暂无图标</div>
				</template>
			</el-table-column>
			<el-table-column prop="level" label="分类等级" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="isShow" label="是否显示" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.isShow">是</p>
					<p v-else>否</p>
				</template>
			</el-table-column>
			<el-table-column prop="updateTime" label="更新时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
		
			<el-table-column  label="操作"  fixed="right" align="center">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="bianji(scope.row.id)">编辑</el-button>
					<el-button size="small" type="text" @click="del(scope.row.id)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		
		<el-dialog style="float:rigin" title="推荐分类" :visible.sync="editDialogVisible" width="50%"
			:closeOnClickModal="false">
			<div class="app-container">
				<el-form ref="form" :model="form"  size="medium">
		
					<el-form-item  label="一级分类:">
						<el-select clearable v-model="classGoods1Id" placeholder="请选择一级分类" style="width:200px;margin-right:10px;"
							@change="classGoods1">
							<el-option clearable v-for="item in classGoods1List" :key="item.id" :label="item.className"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="展示名称:">
						<el-input type="text" style="width: 260px;"  size="small"
							v-model="form.classShowname" placeholder="请输入展示名称" />
					</el-form-item>
				
					<el-form-item label="分类图标:">
						<el-upload :action="httpUrl" list-type="picture-card" :limit='1' :on-preview="handlePictureCardPreview"
							:on-remove="handleRemove" :file-list="fileList" :show-file-list="true"
							:on-success="onSuccess" :before-upload="beforeUpload">
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
		
					<!-- <el-form-item label="图标:">
						<img v-if="form.image" :src="form.image" @click="dialogImageUrl=form.image;dialogVisibleImg=true;"
							width="100px" />
						<div v-else>请上传图片</div>
					</el-form-item> -->
		
					<el-form-item label="排序级别:">
						<el-input type="text" style="width: 260px;" oninput="value=value.replace(/[^0-9.]/g,'')" size="small"
							v-model="form.orderIndex" placeholder="请输入数字" />
					</el-form-item>
					<el-form-item label="是否显示:" class="redItem">
						<el-switch v-model="form.isShow" :active-value="1" :inactive-value="0">
						</el-switch>
					</el-form-item>
					
					<el-form-item>
						<el-button :loading="toEditLoading" type="primary" @click="toEdit()">提交</el-button>
						<el-button @click="editDialogVisible = false">取 消</el-button>
						<!-- <el-button type="primary" @click="insertRoleFunctionFun">确 定</el-button> -->
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>
		
		<el-dialog style="float:rigin" title="编辑推荐分类" :visible.sync="bianjiDialog" width="50%" :close-on-click-modal="false"
			:show-close="false">
			<div class="app-container">
				<el-form ref="form" :model="form2"  size="medium">
					<el-form-item  label="一级分类:">
						<el-select disabled clearable v-model="form2.goodsClassId" placeholder="请选择一级分类" style="width:200px;margin-right:10px;"
							@change="classGoods1">
							<el-option clearable v-for="item in classGoods1List" :key="item.id" :label="item.className"
								:value="item.id"></el-option>
						</el-select>
						<!-- <el-input type="text" v-model="form2.className" disabled /> -->
					</el-form-item>
					<el-form-item label="展示名称:">
						<el-input type="text" style="width: 260px;"  size="small"
							v-model="form2.className" placeholder="请输入展示名称" />
					</el-form-item>
				
					<el-form-item label="分类图标:">
						<el-upload :action="httpUrl" list-type="picture-card" :limit='1' :on-preview="handlePictureCardPreview"
							:on-remove="handleRemove" :file-list="fileList" :show-file-list="true"
							:on-success="onSuccess" :before-upload="beforeUpload">
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
		
					<el-form-item label="排序级别:">
						<el-input type="text" style="width: 260px;" oninput="value=value.replace(/[^0-9.]/g,'')" size="small"
							v-model="form2.orderIndex" placeholder="请输入数字" />
					</el-form-item>
					<el-form-item label="是否显示:" class="redItem">
						<el-switch v-model="form2.isShow" :active-value="1" :inactive-value="0">
						</el-switch>
					</el-form-item>
					
					<el-form-item>
						<el-button :loading="toEdit2Loading" type="primary" @click="toEdit2">提交</el-button>
						<el-button @click="quxiao">取 消</el-button>
						<!-- <el-button type="primary" @click="insertRoleFunctionFun">确 定</el-button> -->
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('remond');
	
	export default{
		data(){
			return{
				searchInfo:{},
				loading:false,
				page: {
					pageNum: 1,
					pageSize: 10
				},
				goodsClassList:[],
				editDialogVisible:false,
				bianjiDialog:false,
				form: {
					id: 0,
					className: "",
					classShowname:'',
					level: "",
					isShow: "",
					image: "",
					orderIndex: 50,
					pid: 0
				},
				form2: {
					id: 0,
					className: "",
					classShowname:'',
					level: "",
					isShow: "",
					image: "",
					orderIndex: 50,
					pid: 0
				},
				classId:'',
				// formLabelWidth: "200px",
				httpUrl: urls,
				goodsImages: {},
				fileList: [],
				contentValue: "",
				showContentDialog: false,
				classGoods1List: [],
				// tableDataList:[ ]
				classGoods1Id:'',
				uploaded:0,
				bjId:'',

				toEditLoading: false,
				toEdit2Loading: false,
			}
		},
		methods:{
			//搜索
			search(){
				this.getClassList()
			},
			//清空
			empty(){
				this.searchInfo = {}
			},
			editialogVisible(){
				this.editDialogVisible = true
			},
			getClassList(){
				this.loading = true
				let data = {
					className:this.searchInfo.className
				}
				this.$api.remonClassList(data).then(res=>{
					console.log(res);
					if(res.state == 'success'){
						this.goodsClassList = res.data
						this.loading = false
					}
				})
			},
			// 添加
			toEdit(){
				// console.log(this.goodsImages);
				
				if(!this.classGoods1Id){
					this.$message.warning('请选择分类');
					
					return 
				}
				this.toEditLoading = true;
				let data = {
					goodsClassId:this.classGoods1Id,
					className:this.form.classShowname,
					image:this.goodsImages.message,
					isShow:this.form.isShow,
					orderIndex:this.form.orderIndex
				}
				this.$api.addremoClass(data).then(res=>{
					// console.log(res);
					if(res.state == 'success'){
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible = false
						this.getClassList()
					}else {
						this.$message.error(res.message);
					}
					this.toEditLoading = false;
				})
			},
			classGoods1(e){
				console.log(e);
				this.classGoods1Id = e
			},
			
			// 删除
			del(id){
				this.$confirm('是否删除该推荐分类?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'error'
				}).then(() => {
					this.$api.delremoClass(id).then(res => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getClassList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			//编辑
			bianji(id){
				this.bjId = id
				this.bianjiDialog = true
				this.$api.selecremoClass(id).then(res=>{
					console.log(res);
					if(res.state == 'success'){
						this.form2 = res.data
						let imagesArray = res.data.image.split(",");
						this.goodsImages = imagesArray;
						for (let i = 0; i < imagesArray.length; i++) {
							this.fileList.push({
								name: imagesArray[i],
								message: imagesArray[i]
							})
						}
						console.log(this.fileList);
					
					}
				})
			},
			quxiao(){
				this.bianjiDialog = false
				this.fileList = []
			},
			//编辑提交
			toEdit2(id){
				// console.log(this.fileList);
				// console.log(this.goodsImages);
				this.this.toEdit2Loading = true;
				let data = {
					id:this.bjId,
					className:this.form2.className,
					image:this.fileList[0].message,
					isShow:this.form2.isShow,
					orderIndex:this.form2.orderIndex
				}
				this.$api.upremoClass(data).then(res=>{
					// console.log(res);
					if(res.state == 'success'){
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.bianjiDialog = false
						this.getClassList()
					}else {
						this.$message.error(res.message);
					}
					this.toEdit2Loading = false;
				})
			},
			beforeUpload(file){
				const img = new Image();
				const _this = this;
				const reader = new FileReader();
				reader.readAsDataURL(file);
				reader.onload = function(e) {
				  img.src = e.target.result;
				  img.onload = function() {
					const width = img.width;
					const height = img.height;
					const isSizeValid = width == 64 && height == 64;
					if (!isSizeValid) {
					  _this.$message.error('上传图片的尺寸必须为 64x64 像素');
					  return false;
					}else{
						 return true;
					}
					
				  };
				};
				// return false
			},
			onSuccess(response, file, fileList) {
				console.log(response)
				this.goodsImages=response;
			
				
				// console.log("asda",response,this.goodsImages)
			},
			handleRemove(file, fileList) {
				if (file.response) {
					this.goodsImages.remove(file.response.message);
				}
				this.goodsImages.remove(file.url);
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisibleImg = true;
			},
			
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
		},
		created() {
			this.getClassList()
			this.$api.goodsClassfindByPid(0).then((res) => { //商品一级分类
				if (res.state == 'success') {
					this.classGoods1List = res.data;
				}
			})
		}
	}
</script>

<style scoped lang="less">
	
	  /deep/.el-upload--picture-card{
		  width: 64px;
		  height: 64px;
		  line-height: 70px;
		  text-align: center;
	  }
</style>